<template>
  <v-dialog
    eager
    v-model="dialog"
    persistent
    fullscreen
    transition="scroll-y-transition"
  >
    <v-app-bar
      absolute
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
      class="white--text navy"
    >
      <v-btn depressed class="white--text" icon @click="dismiss">
        <v-icon>close</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        small
        depressed
        rounded
        class="secondary"
        @click="save"
        :disabled="isAstaInCorso"
        >SALVA</v-btn
      >
    </v-app-bar>

    <v-sheet
      id="scrolling-techniques-7"
      class="overflow-y-auto"
      max-height="100%"
      :class="{ 'nice-scroll': !is_mobile }"
      ref="scrollContainer"
    >
      <v-container fluid pa-0 class="white" style="margin-top: 48px">
        <!-- <v-container fluid pa-0 class="white"> -->

        <!-- Alert se asta in corso -->
        <div
          id="semaforo"
          v-if="isAstaInCorso"
          class="pa-6 error white--text d-flex flex-column align-center justify-center"
        >
          <h3>
            Non è possibile modificare le impostazioni mentre l'asta è in corso!
          </h3>
          <semaforo
            mode="bar"
            class="mt-2"
            :buttons="['play', 'pause', 'stop']"
          ></semaforo>
        </div>

        <!-- Modalità -->
        <v-row no-gutters>
          <v-col>
            <div class="modalita">
              <div class="d-flex justify-center mb-4">
                <div class="px-4 py-1 rounded white--text text--darken-3">
                  SELEZIONA MODALITA' ASTA
                </div>
              </div>
              <v-row justify="center" align="center">
                <v-col
                  cols="auto"
                  v-for="asta_mode in asta_modes"
                  :key="asta_mode"
                >
                  <v-card
                    :class="{ selezionato: asta_mode == mode }"
                    class="asta-mode navy darken-3"
                    elevation="0"
                    @click="setMode(asta_mode)"
                  >
                    <div class="">
                      <v-img
                        contain
                        :src="
                          firebase_host +
                          '/static/img/asta-mode-' +
                          asta_mode +
                          '.png'
                        "
                      ></v-img>
                      <div class="px-5 pb-4 text-center">
                        <h3 class="font-hemi-head white--text">
                          {{ getAstaModeName(asta_mode) }}
                        </h3>

                        <div v-show="asta_mode != mode">SELEZIONA</div>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <!-- <div class="text-center">
                    <v-chip class="" small dark color="text" label>
                      <v-icon left small> school </v-icon> Info Modalità
                    </v-chip>
                  </div> -->
                  <div class="modalita-info white--text primary">
                    <v-icon color="primary darken-2"> school </v-icon>
                    <div v-html="getAstaModeLongDescr(mode)"></div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>

        <!-- Impostazioni-->
        <v-row>
          <v-col>
            <v-card class="page-impostazioni">
              <!-- Opzioni modalità -->
              <div class="text-center mb-4">
                <v-icon color="text"> settings </v-icon>
              </div>

              <!-- stato mercato -->
              <div
                v-if="!Config.STANDALONE && 1 == 2"
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>outlined_flag</v-icon>STATO
                    MERCATO
                  </div>
                  <div class="opzione-descr">
                    L'amministratore di lega deve attivare questo mercato prima
                    di poterlo utilizzare.
                  </div>
                </div>

                <div class="opzione-widget">
                  <a
                    class="text-decoration-none"
                    target="_blank"
                    :href="
                      Config.HOST +
                      '/fantacalcio/modifica-statoMercato/' +
                      asta_info.lega.ID_Lega +
                      '/3'
                    "
                  >
                    <v-btn depressed large outlined :disabled="isAstaInCorso">
                      <span
                        v-if="asta_info.statoMercato == 0"
                        class="statoMercato statoMercato-red"
                        >NON ATTIVO</span
                      >
                      <span v-else class="statoMercato statoMercato-green"
                        >ATTIVO</span
                      >
                      <v-icon right>edit</v-icon>
                      <v-icon x-small right>open_in_new</v-icon>
                    </v-btn>
                  </a>
                </div>
              </div>

              <!-- change admin -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>engineering</v-icon>AMMINISTRATORE
                    ASTA
                  </div>
                  <div class="opzione-descr">
                    L'amministratore d'asta deve rimanere sempre online durante
                    il corso dell'asta o Asta Live si bloccherà.
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-btn
                    large
                    @click="promptChangeAdmin"
                    :disabled="isAstaInCorso"
                    outlined
                  >
                    <span v-if="isAdminSet"
                      >{{ adminUsername }}
                      <span class="stato" :class="adminPresenceClass"></span
                    ></span>
                    <span v-else>Imposta</span>
                    <v-icon right>edit</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- Lega da -->
              <div
                v-if="Config.STANDALONE"
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>groups</v-icon>MAX SQUADRE
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-btn large outlined>
                    {{ asta_info.lega.maxSquadre }}
                    <v-icon right>lock</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- tipologia ruoli -->
              <div
                v-if="Config.STANDALONE"
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>tune</v-icon>TIPOLOGIA RUOLI
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-btn large outlined>
                    {{ tipoRuoli.toUpperCase() }}

                    <v-icon right>lock</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- Listone -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
                v-if="Config.STANDALONE"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>groups</v-icon>MODIFICA RUOLI
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-btn
                    v-if="classic"
                    large
                    @click="promptRuoliCustom"
                    :disabled="isAstaInCorso"
                    outlined
                    >PERSONALIZZA RUOLI
                    <!-- <v-icon right>open_in_new</v-icon> -->
                  </v-btn>

                  <v-btn v-else large outlined>
                    Non modificabili
                    <v-icon right>lock</v-icon>
                  </v-btn>
                </div>
              </div>

              <!-- numero ruoli -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>production_quantity_limits</v-icon
                    >ROSA
                  </div>
                  <div class="opzione-descr">
                    Numero calciatori da dover comprare per ciascun ruolo
                  </div>
                </div>
                <!-- fp -->
                <div v-if="!Config.STANDALONE" class="opzione-widget">
                  <a
                    class="text-decoration-none"
                    target="_blank"
                    :href="
                      Config.HOST +
                      '/fantacalcio/mercato-modifica-n-ruoli/' +
                      asta_info.id
                    "
                  >
                    <v-btn depressed large outlined :disabled="isAstaInCorso">
                      <div
                        v-if="
                          nRuoliComputed && nRuoliComputed.op == 'illimitati'
                        "
                      >
                        <span>Illimitati</span>
                      </div>
                      <div v-else>
                        <span>{{ prefixAcquistabiliPerRuolo() }}</span
                        ><br />
                        <span
                          v-if="nRuoliComputed"
                          class="Ruolo outline Ruolo_1"
                          >{{ nRuoliComputed.nP }}</span
                        >
                        <span
                          v-if="nRuoliComputed"
                          class="Ruolo outline Ruolo_2"
                          >{{ nRuoliComputed.nD }}</span
                        >
                        <span
                          v-if="nRuoliComputed"
                          class="Ruolo outline Ruolo_3"
                          >{{ nRuoliComputed.nC }}</span
                        >
                        <span
                          v-if="nRuoliComputed"
                          class="Ruolo outline Ruolo_4"
                          >{{ nRuoliComputed.nA }}</span
                        >
                      </div>
                      <v-icon right>edit</v-icon>
                      <v-icon x-small right>open_in_new</v-icon>
                    </v-btn>
                  </a>
                </div>
                <!-- standalone -->
                <div v-else class="opzione-widget">
                  <div class="d-flex align-center justify-end">
                    <!-- <v-select
                      :items="nRuoli_op_opt"
                      v-model="nRuoli_op"
                      :disabled="isAstaInCorso"
                      outlined
                    ></v-select> -->
                    <div v-if="asta_info.lega.nRuoli.op == 'illimitati'">
                      <v-btn large outlined>
                        Illimitati / A piacere
                        <v-icon right>lock</v-icon>
                      </v-btn>
                    </div>
                    <div v-else class="d-flex align-center justify-center">
                      <v-select
                        v-model="nRuoli_nP"
                        :items="[1, 2, 3, 4, 5]"
                        label="Por"
                        outlined
                        class="ma-2"
                      ></v-select>
                      <v-select
                        v-model="nRuoli_nD"
                        :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="Dif"
                        outlined
                        class="ma-2"
                      ></v-select>
                      <v-select
                        v-model="nRuoli_nC"
                        :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]"
                        label="Cen"
                        outlined
                        class="ma-2"
                      ></v-select>
                      <v-select
                        v-model="nRuoli_nA"
                        :items="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                        label="Att"
                        outlined
                        class="ma-2"
                      ></v-select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- RUOLO DA CHIAMARE -->
              <div
                v-if="classic"
                id="ruolo_da_chiamare"
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>gavel</v-icon>RUOLO DA CHIAMARE
                    <v-badge color="error" content="NEW" offset-x="-5">
                    </v-badge>
                  </div>
                  <div class="opzione-descr">
                    Utile per le leghe che vogliono fare l'asta ruolo per
                    ruolo.<br />
                    Selezionando "Qualunque ruolo", il chiamante potrà chiamare
                    all'asta un calciatore del ruolo che preferisce.
                  </div>
                </div>
                <div class="opzione-widget">
                  <div @click="handleDisabledClick">
                    <v-select
                      :items="ruolo_da_chiamare_options"
                      v-model="ruolo_da_chiamare"
                      :disabled="isAstaInCorso"
                      outlined
                    ></v-select>
                  </div>
                </div>
              </div>

              <!-- Chiamante v-show-->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
                v-if="mode != Constants.ASTA_MODE.ASSEGNA"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>gavel</v-icon>CHIAMANTE
                  </div>
                  <div class="opzione-descr">
                    - <strong>A turno tutti (senza passo)</strong>: la
                    scelta/estrazione del giocatore da mettere all'asta spetta a
                    turno ad ogni partecipante, senza possibilità di passare il
                    turno<br />
                    - <strong>A turno tutti (con passo)</strong>: come la
                    precedente ma con la possibilità di passare il turno<br />
                    - <strong>Solo l'admin</strong>: è sempre l'amministratore
                    di lega a sceglierli/estrarli
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-select
                    :items="ch_mode_opt"
                    v-model="ch_mode"
                    :disabled="isAstaInCorso"
                    outlined
                  ></v-select>
                </div>
              </div>

              <!-- ESTRAZIONE CASUALE-->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>shuffle</v-icon> ESTRAZIONE
                    CASUALE
                  </div>
                  <div class="opzione-descr">
                    - <strong>NO</strong>: il calciatore viene scelto
                    liberamente dal 'Chiamante'<br />
                    - <strong>SI</strong>: Il 'Chiamante' estrae il calciatore
                    in maniera casuale tra i ruoli permessi
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-select
                    v-bind:items="random_mode_opt"
                    v-model="random_mode"
                    :disabled="isAstaInCorso"
                    outlined
                  ></v-select>
                </div>
              </div>

              <!-- BASE D'ASTA v-show-->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
                v-if="mode !== Constants.ASTA_MODE.ASSEGNA"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>outlined_flag</v-icon>BASE D'ASTA
                  </div>
                  <div class="opzione-descr">
                    L'offerta minima per ciascun calciatore.
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-select
                    v-bind:items="offerta_min_opt"
                    v-model="base_asta"
                    :disabled="isAstaInCorso"
                    outlined
                  ></v-select>
                </div>
              </div>

              <!-- OFFERTA CONTESTUALE ALLA CHIAMATA? v-show-->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
                v-if="
                  !(
                    latestProp('random_mode') ==
                      Constants.RANDOM_MODE.ENABLED ||
                    latestProp('mode') == Constants.ASTA_MODE.BUSTA_CHIUSA ||
                    latestProp('mode') == Constants.ASTA_MODE.ADMIN ||
                    latestProp('ch_mode') == Constants.CHOOSER_MODE.ADMIN
                  )
                "
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>currency_exchange</v-icon>OFFERTA
                    CONTESTUALE ALLA CHIAMATA?
                  </div>
                  <div class="opzione-descr">
                    - <strong>SI</strong>: Quando il 'Chiamante' sceglie un
                    calciatore sta anche offrendo il valore impostato in 'Base
                    d'asta' (Attenzione: il sistema mostrerà al chiamante SOLO
                    gli svincolati aquistabili col suo credito residuo)<br />
                    - <strong>NO</strong>: il 'Chiamante' non fa offerta => se
                    nessuno farà offerte, il calciatore verrà scartato<br /><br />
                    Attenzione. Questa impostazione <b> sarà ignorata se</b>: a)
                    la modalità è Busta Chiusa, b) il chiamante è sempre l'admin
                    o c) l'estrazione è casuale.
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-select
                    :items="offerta_auto_opt"
                    v-model="offerta_auto"
                    :disabled="isAstaInCorso"
                    outlined
                  ></v-select>
                </div>
              </div>

              <!-- ORDINA SVINCOLATI PER -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>sort</v-icon>ORDINA SVINCOLATI PER
                  </div>
                  <div class="opzione-descr">
                    Utile per le leghe che chiamano i calciatori da mettere
                    all'asta in ordine alfabetico o quotazione.
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-select
                    v-bind:items="chooser_list_order_opt"
                    v-model="ch_list_order"
                    :disabled="isAstaInCorso"
                    outlined
                  ></v-select>
                </div>
              </div>

              <!-- TIMEOUT CHIAMATA CALCIATORE -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>av_timer</v-icon> TIMEOUT CHIAMATA
                    CALCIATORE
                  </div>
                  <div class="opzione-descr">
                    Quanto tempo ha a disposizione il 'Chiamante' per
                    scegliere/estrarre il calciatore? Passato questo tempo, il
                    sistema sceglierà automaticamente il primo della lista degli
                    svincolati del ruolo visualizzato in quel momento.
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-text-field
                    v-model="timeout_c"
                    type="number"
                    suffix="secondi"
                    :disabled="true"
                  ></v-text-field>
                  <v-slider
                    v-bind:max="300"
                    v-bind:min="5"
                    :disabled="isAstaInCorso"
                    v-model="timeout_c"
                    step="5"
                    snap
                    hide-details
                  ></v-slider>
                </div>
              </div>

              <!-- TIMEOUT RILANCIO -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>av_timer</v-icon>TIMEOUT RILANCIO
                  </div>
                  <div class="opzione-descr">
                    Una volta che è stato scelto il calciatore da mettere
                    all'asta, quanto tempo ha a disposizione ciascun
                    partecipante per decidere se fare un'offerta o passare?
                    Scaduto tale tempo, il sistema forzerà un PASSO
                  </div>
                </div>
                <div class="opzione-widget">
                  <v-text-field
                    v-model="timeout_s"
                    type="number"
                    suffix="secondi"
                    :disabled="true"
                  ></v-text-field>
                  <v-slider
                    v-bind:max="300"
                    v-bind:min="5"
                    :disabled="isAstaInCorso"
                    v-model="timeout_s"
                    hide-details
                    step="5"
                    snap
                    class="mb-0 mt-0"
                  ></v-slider>
                </div>
              </div>

              <!-- Limit club -->
              <div
                v-if="!Config.STANDALONE"
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>production_quantity_limits</v-icon
                    >MAX CALCIATORI PER CLUB PER RUOLO
                  </div>
                  <div class="opzione-descr">
                    Es: impostando 2 una fantasquadra potrà avere massimo 2
                    attaccanti (e max 2 centrocampisti, max 2 difensori, max 2
                    portieri) di ciascun club (Inter, Milan...)
                  </div>
                </div>
                <div class="opzione-widget">
                  <a
                    class="text-decoration-none"
                    target="_blank"
                    :href="
                      Config.HOST +
                      '/fantacalcio/modifica-limitRosaPerClub/' +
                      asta_info.id
                    "
                  >
                    <v-btn outlined large depressed :disabled="isAstaInCorso">
                      <div
                        v-if="
                          limitRosaPerClub &&
                          limitRosaPerClub.perClubPerRuolo.active == 1
                        "
                      >
                        <span
                          >{{ limitRosaPerClub.perClubPerRuolo.valore }} per
                          ruolo</span
                        >
                      </div>
                      <div v-else>
                        <span>Nessun limite</span>
                      </div>
                      <v-icon right>edit</v-icon>
                      <v-icon x-small right>open_in_new</v-icon>
                    </v-btn>
                  </a>
                </div>
              </div>

              <!-- Altro -->
              <div
                class="opzione d-flex flex-column align-start flex-md-row justify-md-space-between"
              >
                <div class="opzione-titolo-descr">
                  <div class="opzione-titolo">
                    <v-icon color="text" left>mode_edit</v-icon>ALTRE MODIFICHE
                  </div>
                  <div class="opzione-descr" v-if="Config.STANDALONE">
                    Altre opzioni (es: modifica dei crediti di squadra) le trovi
                    direttamente nella schermata principale (cliccando sulle
                    squadre intorno al "tavolo")
                  </div>
                  <div v-else class="opzione-descr">
                    Altre opzioni le trovi sia nella schermata principale
                    (cliccando sulle squadre intorno al "tavolo") che sul
                    sito/app. Ricorda però che se modifichi qualcosa sul
                    sito/app, poi in Asta Live dovrai sincronizzare le modifiche
                    e perderai le eventuali assegnazioni non salvate.
                  </div>
                </div>
                <div class="opzione-widget"></div>
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Salva -->
        <!-- <div class="text-center ma-2">
          <v-btn
            large
            rounded
            class="secondary"
            @click="save"
            :disabled="isAstaInCorso"
            >Salva</v-btn
          >
        </div> -->
      </v-container>
    </v-sheet>

    <!-- </v-sheet> -->
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import Config from "../../../config-app/config";
import * as Helpers from "../../js/helpers";

import mixins from "../../js/mixins";
import toast from "../../js/toast";

import Vuex from "vuex";
import Semaforo from "../common/Semaforo";

export default {
  name: "asta-impostazioni",
  mixins: [mixins, toast],
  components: {
    Semaforo,
  },
  data() {
    return {
      firebase_host: Config.FIREBASE_HOST,
      btnDisabled: false,
      dialog: false,
      asta_modes: [
        Constants.ASTA_MODE.SELVAGGIA,
        Constants.ASTA_MODE.POKER,
        Constants.ASTA_MODE.BUSTA_CHIUSA,
        Constants.ASTA_MODE.ASSEGNA,
      ],
      chooser_list_order_opt: [
        { text: "Quotazione", value: Constants.CHOOSER_LIST_ORDER.QUOTAZIONE },
        { text: "Nome", value: Constants.CHOOSER_LIST_ORDER.NOME },
      ],
      ruolo_da_chiamare_options: [
        { text: "P", value: Constants.RUOLI_NEW[1].ruolo_id },
        { text: "D", value: Constants.RUOLI_NEW[2].ruolo_id },
        { text: "C", value: Constants.RUOLI_NEW[3].ruolo_id },
        { text: "A", value: Constants.RUOLI_NEW[4].ruolo_id },
        { text: "Qualunque ruolo", value: 0 },
      ],
      ch_mode_opt: [
        //{text: 'Auto', value: Constants.CHOOSER_MODE.AUTO},
        {
          text: "A turno tutti (senza passo)",
          value: Constants.CHOOSER_MODE.MANUAL,
        },
        {
          text: "A turno tutti (con passo)",
          value: Constants.CHOOSER_MODE.MANUAL_PASSO,
        },
        { text: "Solo l'admin", value: Constants.CHOOSER_MODE.ADMIN },
      ],
      random_mode_opt: [
        { text: "NO", value: Constants.RANDOM_MODE.DISABLED },
        { text: "SI", value: Constants.RANDOM_MODE.ENABLED },
      ],
      offerta_min_opt: [
        { text: "1", value: Constants.BASE_ASTA.UNO },
        { text: "Quotazione", value: Constants.BASE_ASTA.QUOTAZIONE },
      ],
      offerta_auto_opt: [
        { text: "SI", value: Constants.OFFERTA_AUTO.ENABLED },
        { text: "NO", value: Constants.OFFERTA_AUTO.DISABLED },
      ],
      nRuoli_op_opt: [
        { text: "illimitati", value: Constants.NRUOLI_OP.ILLIMITATI },
        { text: "esattamente", value: Constants.NRUOLI_OP.ESATTAMENTE },
      ],

      // v-models
      timeout_s: 0,
      timeout_c: 0,
      mode: 0,
      ch_mode: null,
      ruolo_da_chiamare: null,
      random_mode: null,
      base_asta: null,
      offerta_auto: null,
      ch_list_order: null,
      nRuoli_op: null,
      nRuoli_nP: null,
      nRuoli_nD: null,
      nRuoli_nC: null,
      nRuoli_nA: null,

      //
      settings: {
        ch_mode: "",
      },
      lega: {},
    };
  },
  mounted() {
    console.log("--> AstaImpostazioni ready.");
    db.on("showImpostazioni", this.show);
  },
  destroyed() {
    console.log("<-- AstaImpostazioni destroyed.");
    db.off("showImpostazioni", this.show);
  },
  methods: {
    promptRuoliCustom() {
      db.emit("promptRuoliCustom");
    },
    promptChangeAdmin() {
      db.emit("promptChangeAdmin");
    },
    gotoAdminLega() {
      window.open(
        Config.HOST + "/fantacalcio/gestione-lega/admin/" + this.asta_info.id
      );
    },
    handleDisabledClick() {
      if (this.isAstaInCorso) {
        const headerHeight = document.querySelector("header").offsetHeight + 15;
        this.$scrollTo("#semaforo", 500, {
          container: this.$refs.scrollContainer.$el,
          offset: -headerHeight,
        });
      }
    },
    latestProp(propName) {
      return this.settings[propName] !== undefined
        ? this.settings[propName]
        : this.asta_settings[propName];
    },
    setMode: function (m) {
      if (this.isAstaInCorso) {
        Swal.fire({
          title: "Round in corso",
          text: "Per salvare le impostazioni devi fermare prima l'asta.",
          icon: "warning",
          confirmButtonText: "Ho capito",
        });
        return;
      }

      this.mode = m;
    },
    // modeClass: function (mode) {
    //   return {
    //     "primary darken-1": this.mode === mode,
    //     "navy darken-3": this.mode !== mode,
    //   };
    // },
    show(scrollTo = "") {
      this.dialog = true;
      this.resetImpostazioni();
      // scroll to target if passed
      if (scrollTo != "") {
        this.$nextTick(() => {
          const headerHeight =
            document.querySelector("header").offsetHeight + 15;
          this.$scrollTo(scrollTo, 500, {
            container: this.$refs.scrollContainer.$el,
            offset: -headerHeight,
          });
        });
      }
    },
    dismiss() {
      this.dialog = false;
      this.settings = {};
    },
    resetImpostazioni() {
      this.timeout_s = this.asta_settings.timeout_s;
      this.timeout_c = this.asta_settings.timeout_c;
      this.ch_list_order = this.asta_settings.ch_list_order;
      this.ruolo_da_chiamare = this.asta_settings.ruolo_da_chiamare;
      this.ch_mode = this.asta_settings.ch_mode;
      this.random_mode = this.asta_settings.random_mode;
      this.base_asta = this.asta_settings.base_asta;
      this.offerta_auto = this.asta_settings.offerta_auto;
      this.mode = this.asta_settings.mode;

      if (Config.STANDALONE) {
        this.nRuoli_op = this.asta_info.lega.nRuoli.op;
        this.nRuoli_nP = this.asta_info.lega.nRuoli.nP;
        this.nRuoli_nD = this.asta_info.lega.nRuoli.nD;
        this.nRuoli_nC = this.asta_info.lega.nRuoli.nC;
        this.nRuoli_nA = this.asta_info.lega.nRuoli.nA;
      }
    },
    preSave() {
      const mode = this.latestProp("mode");
      const ch_mode = this.latestProp("ch_mode");
      const random_mode = this.latestProp("random_mode");
      const offerta_auto = this.latestProp("offerta_auto");

      //sanitize IF (negazione v-show )
      if (mode == Constants.ASTA_MODE.ASSEGNA) {
        this.settings.ch_mode = Constants.CHOOSER_MODE.ADMIN;
        this.settings.base_asta = Constants.BASE_ASTA.UNO;
      }
      if (
        random_mode == Constants.RANDOM_MODE.ENABLED ||
        ch_mode == Constants.CHOOSER_MODE.ADMIN ||
        mode == Constants.ASTA_MODE.BUSTA_CHIUSA
      ) {
        if (offerta_auto == Constants.OFFERTA_AUTO.ENABLED) {
          this.successToast(
            "Attenzione",
            "Offerta contestuale NON compatibile con le altre opzioni scelte. Verrà ignorata."
          );
        }
        this.settings.offerta_auto = Constants.OFFERTA_AUTO.DISABLED;
      }
    },
    save() {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }

      // if (this.admin) {
      this.preSave();
      if (_.size(this.settings)) {
        db.setSettings(this.settings).then(
          () => {
            // se ho cambiato ruolo_da_chiamare, riattiva tutte le squadre
            if (this.settings.ruolo_da_chiamare !== undefined) {
              db.updateSquadreActive(this.asta_squadre, 1);
            }
            this.dismiss();
          },
          (err) => {
            this.errorToast("Errore", "Operazione non consentita ");
            console.error(err);
          }
        );
      }
      if (Config.STANDALONE) {
        if (_.size(this.lega)) {
          db.setLegaSettings(this.lega).then(
            () => {
              this.dismiss();
            },
            (err) => {
              this.errorToast("Errore", "Operazione non consentita ");
              console.error(err);
            }
          );
        }
      }
    },
  },
  watch: {
    // la logica è identica alle computed
    // mantenere nelle form properties solo i valori che sono diversi rispetto allo stato
    // (immagino per non andare a scrivere in firebase cose uguali? nn avrebbe molto senso. Forse c'è dell'altro)
    // cn questo metodo se cambio senza salvare e rientro in impostazioni, trovo il vecchio valore giusto
    timeout_s: function (newValue) {
      if (newValue != this.asta_settings.timeout_s) {
        this.settings = Object.assign({}, this.settings, {
          timeout_s: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "timeout_s");
      }
    },
    timeout_c: function (newValue) {
      if (newValue != this.asta_settings.timeout_c) {
        this.settings = Object.assign({}, this.settings, {
          timeout_c: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "timeout_c");
      }
    },
    mode: function (newValue) {
      if (newValue != this.asta_settings.mode) {
        this.settings = Object.assign({}, this.settings, { mode: newValue });
      } else {
        this.settings = _.omit(this.settings, "mode");
      }
    },
    ch_mode: function (newValue) {
      if (newValue != this.asta_settings.ch_mode) {
        this.settings = Object.assign({}, this.settings, { ch_mode: newValue });
      } else {
        this.settings = _.omit(this.settings, "ch_mode");
      }
    },
    ruolo_da_chiamare: function (newValue) {
      if (newValue != this.asta_settings.ruolo_da_chiamare) {
        this.settings = Object.assign({}, this.settings, {
          ruolo_da_chiamare: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "ruolo_da_chiamare");
      }
    },
    random_mode: function (newValue) {
      if (newValue != this.asta_settings.random_mode) {
        this.settings = Object.assign({}, this.settings, {
          random_mode: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "random_mode");
      }
    },
    base_asta: function (newValue) {
      if (newValue != this.asta_settings.base_asta) {
        this.settings = Object.assign({}, this.settings, {
          base_asta: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "base_asta");
      }
    },
    offerta_auto: function (newValue) {
      if (newValue != this.asta_settings.offerta_auto) {
        this.settings = Object.assign({}, this.settings, {
          offerta_auto: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "offerta_auto");
      }
    },
    ch_list_order: function (newValue) {
      if (newValue != this.asta_settings.ch_list_order) {
        this.settings = Object.assign({}, this.settings, {
          ch_list_order: newValue,
        });
      } else {
        this.settings = _.omit(this.settings, "ch_list_order");
      }
    },
    nRuoli_op: function (newValue) {
      this.lega.nRuoli = Object.assign({}, this.lega.nRuoli, {
        op: newValue,
      });
    },

    nRuoli_nP: function (newValue) {
      this.lega.nRuoli = Object.assign({}, this.lega.nRuoli, {
        nP: newValue,
      });
    },

    nRuoli_nD: function (newValue) {
      this.lega.nRuoli = Object.assign({}, this.lega.nRuoli, {
        nD: newValue,
      });
    },

    nRuoli_nC: function (newValue) {
      this.lega.nRuoli = Object.assign({}, this.lega.nRuoli, {
        nC: newValue,
      });
    },

    nRuoli_nA: function (newValue) {
      this.lega.nRuoli = Object.assign({}, this.lega.nRuoli, {
        nA: newValue,
      });
    },
  },
  computed: {
    // SquadraAdminName() {
    //   if (this.admin) {
    //     return "Sei tu";
    //   }
    //   return this.asta_squadre[this.adminUid]
    //     ? this.asta_squadre[this.adminUid].name
    //     : "";
    // },
    // la logica è:
    // mantenere nelle form properties solo i valori che sono diversi rispetto allo stato
    // (immagino per non andare a scrivere in firebase cose uguali? nn avrebbe molto senso. Forse c'è dell'altro)
    // ch_list_order: {
    //   get: function () {
    //     return this.asta_settings.ch_list_order;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if (newValue != this.asta_settings.ch_list_order) {
    //       this.settings = Object.assign({}, this.settings, {
    //         ch_list_order: newValue,
    //       });
    //     } else {
    //       this.settings = _.omit(this.settings, "ch_list_order");
    //     }
    //   },
    // },
    // ruolo_da_chiamare: {
    //   get: function () {
    //     return this.asta_settings.ruolo_da_chiamare;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if (newValue != this.asta_settings.ruolo_da_chiamare) {
    //       this.settings = Object.assign({}, this.settings, {
    //         ruolo_da_chiamare: newValue,
    //       });
    //     } else {
    //       this.settings = _.omit(this.settings, "ruolo_da_chiamare");
    //     }
    //   },
    // },
    // ch_mode: {
    //   get: function () {
    //     return this.asta_settings.ch_mode;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if (newValue != this.asta_settings.ch_mode) {
    //       this.settings = Object.assign({}, this.settings, {
    //         ch_mode: newValue,
    //       });
    //     } else {
    //       this.settings = _.omit(this.settings, "ch_mode");
    //     }
    //   },
    // },
    // random_mode: {
    //   get: function () {
    //     return this.asta_settings.random_mode || 0;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if (newValue != this.asta_settings.random_mode) {
    //       this.settings = Object.assign({}, this.settings, {
    //         random_mode: newValue,
    //       });
    //     } else {
    //       this.settings = _.omit(this.settings, "random_mode");
    //     }
    //   },
    // },
    // base_asta: {
    //   get: function () {
    //     return this.asta_settings.base_asta;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if (newValue != this.asta_settings.base_asta) {
    //       this.settings = Object.assign({}, this.settings, {
    //         base_asta: newValue,
    //       });
    //     } else {
    //       this.settings = _.omit(this.settings, "base_asta");
    //     }
    //   },
    // },
    // offerta_auto: {
    //   get: function () {
    //     return this.asta_settings.offerta_auto;
    //   },
    //   // setter
    //   set: function (newValue) {
    //     if (newValue != this.asta_settings.offerta_auto) {
    //       this.settings = Object.assign({}, this.settings, {
    //         offerta_auto: newValue,
    //       });
    //     } else {
    //       this.settings = _.omit(this.settings, "offerta_auto");
    //     }
    //   },
    // },

    // usata solo da non standalone
    nRuoliComputed() {
      if (this.asta_info && this.asta_info.lega && this.asta_info.lega.nRuoli) {
        return this.asta_info.lega.nRuoli;
      } else {
        return null;
      }
    },
    limitRosaPerClub() {
      if (
        this.asta_info &&
        this.asta_info.lega &&
        this.asta_info.lega.limitRosaPerClub
      ) {
        return this.asta_info.lega.limitRosaPerClub;
      } else {
        return null;
      }
    },
    ...Vuex.mapGetters(["asta_squadre_array", "is_mobile"]),
  },
};
</script>
<style lang="scss" scoped>
.modalita {
  background-color: var(--v-navy-base) !important;
  background-image: linear-gradient(
    182deg,
    var(--v-navy-base),
    var(--v-navy-darken2) 550px
  ) !important;
  color: white !important;
  padding: 15px 10px 90px 10px;
  .v-btn {
    min-width: 170px !important;
    border-radius: 100px;
  }
}

.opzione {
  margin-bottom: 30px;
}
.opzione-titolo {
  // font-size: 13px;
}
.opzione-descr {
  color: var(--v-grey-lighten1);
  margin-bottom: 10px;
  margin-left: 30px;
}
.opzione-widget {
  // max-width: 250px;
  // min-width: 250px;
  padding-left: 30px;
}
.modalita-info {
  text-align: center;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  width: fit-content;
}
.page-impostazioni {
  margin: -75px 30px 0px 30px;
  padding: 30px;
  .card__title {
    font-weight: bold;
    padding-bottom: 0;
  }
}
.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.info-row-icon {
  padding-right: 15px;
}
.info-title {
  font-weight: bold;
}

.asta-mode {
  max-width: 250px;
  height: 240px;

  &.selezionato {
    box-shadow: 0px 0px 0px 1px var(--v-secondary-base) !important;
    height: 250px;
  }

  &:not(.selezionato) {
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .v-image {
    height: 175px;
  }
  @media screen and (max-width: 1024px) {
    max-width: 150px;
    height: 200px;
    &.selezionato {
      height: 210px;
    }
    .v-image {
      height: 125px;
    }
  }
}
</style>
